import {
    IComment,
    IRobot,
    IUser,
} from '@models';
import { ISuggestValue } from '@uipath/angular/components/ui-suggest/models';

import { Moment } from 'moment';

export interface IQueueUpsert {
    id?: number;
    name: string;
    description?: string;
    maxNoOfRetries: number;
    acceptAutoRetry: boolean;
    enforceUniqueReference: boolean;
    specificDataJsonSchema?: string;
    outputDataJsonSchema?: string;
    analyticsDataJsonSchema?: string;
    slaMinutes: number;
    riskSlaMinutes: number;
    releaseId?: number;
    releaseKey?: ISuggestValue[];
    triggerId: number | null;
}

export interface IQueue extends IQueueUpsert {
    id: number;
    processId?: number;
    processName?: string;
}

export interface IQueueItemIdentifier {
    id: number;
    rowVersion?: string;
    reviewer?: IUser;
}

export interface IQueueItem {
    id: number;
    key: string;
    reference: string;
    progress: string;
    priority: QueueItemPriority;
    deferDate?: Date;
    dueDate?: Date;
    queueDefinitionId: number;
    status: string;
    processingExceptionId?: number;
    processingExceptionType?: string;
    processingException?: any;
    startProcessing?: Date;
    reviewerUser: IUser;
    endProcessing?: Date;
    anchestorId?: number;
    retryNumber?: number;
    creationTime: Date;
    specificContent: string;
    output: string;
    analytics?: string;
    reviewStatus?: string;
    rowVersion?: string;
    queueDefinition: IQueue;
    robot: IRobot;
}

export interface IQueueItemComment extends IComment {
    queueItemId: number;
}

export interface IQueueItemEvent {
    id: number;
    queueItemId: number;
    timestamp: string;
    action: string;
    data: string;
    userId: number;
    userName: string;
    status: string;
    reviewStatus: string;
    reviewerUserId: number;
    reviewerUserName: string;
}

export enum QueueJsonSchema {
    Specific,
    Analytics,
    Output,
}

export enum QueueItemPriority {
    low = 'Low',
    normal = 'Normal',
    high = 'High',
}

export interface IQueueItemRow {
    reference?: string;
    priority?: QueueItemPriority;
    dueDate?: Moment;
    deferDate?: Moment;
    specificContent?: Record<string, string | boolean | number | undefined>;
    progress?: string;
}

export interface IQueueItemDto extends IQueueItemRow {
    name: string;
}

export type IQueueItemDtoWithItemId = IQueueItemDto & {
    id: number;
    slaEnabled: boolean;
};
